// extracted by mini-css-extract-plugin
module.exports = {"root":"tagButton_root__ee7hs","selected":"tagButton_selected__FNJ_O"};